import CompanyView from '../../components/settings/company'
import BranchView from '../../components/settings/branch'
import PrinterView from '../../components/settings/printer'
export default {
  components: {
    CompanyView,
    BranchView,
    PrinterView
  },
  mounted () {
    this.checkUser()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/setting.js